import { render, staticRenderFns } from "./exhibition-template-trade.vue?vue&type=template&id=3f954a2e&scoped=true&"
import script from "./exhibition-template-trade.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-trade.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-trade.vue?vue&type=style&index=0&id=3f954a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f954a2e",
  null
  
)

export default component.exports